import React from 'react';
import { Translation } from 'react-i18next';

import './SocialLinksEmptyPlaceholder.css';

const SocialLinksEmptyPlaceholder = () => (
  <Translation>
    {(t) => (
      <div className="social-links-empty-placeholder">
        <div className="image-wrapper" />
        <div className="text">
          You haven't added any Social Links
        </div>
      </div>
    )}
  </Translation>
);

export default SocialLinksEmptyPlaceholder;
